/** PDP header Sale / Sold out / Preorder badges: mirror the variant:update server render, falling back to the variant resource. */
(function () {
  if (window.__caPdpBadgesInit) return;
  window.__caPdpBadgesInit = true;

  var BADGES = [
    {
      selector: '[data-ca-sale-badge]',
      fallback: function (resource) {
        if (resource && resource.compare_at_price != null) {
          return Number(resource.compare_at_price) > Number(resource.price) && resource.available !== false;
        }
        return null;
      },
    },
    {
      selector: '[data-ca-sold-out-badge]',
      fallback: function (resource) {
        if (resource && typeof resource.available === 'boolean') return resource.available === false;
        return null;
      },
    },
    {
      selector: '[data-ca-preorder-badge]',
      fallback: function () {
        return null;
      },
    },
  ];

  document.addEventListener('variant:update', function (event) {
    var detail = event.detail || {};
    var scope = (event.target.closest && event.target.closest('.shopify-section')) || document;
    var doc = detail.data && detail.data.html;

    BADGES.forEach(function (config) {
      var badges = scope.querySelectorAll(config.selector);
      if (!badges.length) return;

      var show = null;
      if (doc && typeof doc.querySelector === 'function') {
        var fresh = doc.querySelector(config.selector);
        if (fresh) show = !fresh.hasAttribute('hidden');
      }
      if (show === null) show = config.fallback(detail.resource);
      if (show === null) return;

      for (var i = 0; i < badges.length; i++) {
        if (show) {
          badges[i].removeAttribute('hidden');
        } else {
          badges[i].setAttribute('hidden', '');
        }
      }
    });
  });
})();
